import { tap, bind } from 'ramda';
import { create, env } from 'sanctuary';
import $ from 'sanctuary-def';

//    HtmlElement :: Type
const HtmlElement = $.NullaryType(
  'common/HtmlElement',
  '',
  x => /^\[object HTML.*Element\]$/.test(Object.prototype.toString.call(x)),
);

const opts = {
  checkTypes: process.env.NODE_ENV !== 'production',
  env: env.concat([HtmlElement]),
};

const def = $.create(opts);
const S = create(opts);

export const maybeShape = (props, propName, componentName) => {
  if (!S.is(S.Maybe, props[propName])) {
    return new Error(
      `Invalid prop '${propName}' supplied to '${componentName}'.\n
       [Maybe] expected, but provided: ${S.type(props[propName]).name}.`,
    );
  }

  return null;
};

export const eitherShape = (props, propName, componentName) => {
  if (!S.is(S.Either, props[propName])) {
    return new Error(
      `Invalid prop '${propName}' supplied to '${componentName}'.\n
       [Either] expected, but provided: ${S.type(props[propName]).name}.`,
    );
  }

  return null;
};

export const log = def('log', {}, [$.Any, $.Any], tap(bind(console.log, console)));

export default S;
